import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { ChevronDown, ChevronUp } from "lucide-react";

const formatLong = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" }); } catch { return iso; }
};

export default function BulletinsSection() {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    api.get("/bulletins").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;
  const visible = expanded ? items : items.slice(0, 2);

  return (
    <section
      data-testid="bulletins-section"
      className="bg-white rounded-2xl border-2 border-[#D1C9C1] shadow-sm overflow-hidden"
    >
      <div className="bg-[#8A3A33] text-white px-5 py-3 flex items-center gap-2">
        <span className="text-xl">📢</span>
        <h2 className="font-serif text-lg sm:text-xl font-bold">Boletín Digital</h2>
      </div>
      <div className="divide-y divide-[#D1C9C1]">
        {visible.map((b) => (
          <article key={b.id} className="p-5 sm:p-6" data-testid={`bulletin-${b.id}`}>
            <h3 className="font-serif text-xl font-bold text-[#1A1818] mb-1">{b.title}</h3>
            <p className="text-sm text-[#4A4646] mb-3">
              {b.author_name} · {formatLong(b.publish_at)}
            </p>
            <p className="text-base text-[#4A4646] leading-relaxed whitespace-pre-wrap">{b.content}</p>
          </article>
        ))}
      </div>
      {items.length > 2 && (
        <button
          onClick={() => setExpanded(!expanded)}
          data-testid="bulletins-toggle"
          className="w-full px-5 py-3 text-[#8A3A33] hover:bg-[#F3F1EF] text-sm font-semibold flex items-center justify-center gap-1 border-t-2 border-[#D1C9C1]"
        >
          {expanded ? <>Ver menos <ChevronUp className="w-4 h-4" /></> : <>Ver {items.length - 2} más <ChevronDown className="w-4 h-4" /></>}
        </button>
      )}
    </section>
  );
}
